import fetch from "auth/FetchInterceptor";

const RoleService = {};

RoleService.index = function () {
  return fetch({
    url: "/roles",
    method: "get",
  });
};

RoleService.create = function (data) {
  return fetch({
    url: "/roles",
    method: "post",
    data,
  });
};

RoleService.update = function (id, data) {
  return fetch({
    url: `/roles/${id}`,
    method: "put",
    data,
  });
};

export default RoleService;
